
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq9v6GBTeF8_451xx9kuQtwxON9FOMpoGgTFYw9mkxscjkgMeta } from "/codebuild/output/src1799359565/src/src/pages/faq.vue?macro=true";
import { default as menuFSYBgNDbir88gc_45_45u8S7C6Hl0APDWMxct9P0SOWpoAgMeta } from "/codebuild/output/src1799359565/src/src/pages/menu.vue?macro=true";
import { default as indexes1xavIQ_459mQ0U4tlu5D5VJjbV7TWm3D_yFsY8Xsy1UMeta } from "/codebuild/output/src1799359565/src/src/pages/index.vue?macro=true";
import { default as contactpy32eUKQQXnI_31L66IVrNL4fLcQAwJA9on84t2Ly0sMeta } from "/codebuild/output/src1799359565/src/src/pages/contact.vue?macro=true";
import { default as tutorialXVZvjK8JLlHWMkMPy1iLXZPZY8MSHW2E5FHV57mbNbIMeta } from "/codebuild/output/src1799359565/src/src/pages/tutorial.vue?macro=true";
import { default as agreementYOA36_45bwxDFpYjaV3W1HvKvooozvJWTEpOC0DfWkn7gMeta } from "/codebuild/output/src1799359565/src/src/pages/agreement.vue?macro=true";
import { default as about_45passOM1bgWCdKI_imLnKj4PAdMA_gbA51uxq8gBw9bPCWxsMeta } from "/codebuild/output/src1799359565/src/src/pages/about-pass.vue?macro=true";
import { default as index9ixelVkoS_45vWNSxIjTbE7zRl9kLOuYR2rqxOcOkFOcIMeta } from "/codebuild/output/src1799359565/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93DBV27uXjjSk2JePIO8N8RaJIaLLqfjpBPQnNcBKDYeUMeta } from "/codebuild/output/src1799359565/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance3cgUgeojjE8LDMv_cbTKOg2iTXw_45Ck_VQswlkA1NFwwMeta } from "/codebuild/output/src1799359565/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93hmCZuKedOW3gJRkruvFc7mwbdJYu_45_xEmVsx2UvwnygMeta } from "/codebuild/output/src1799359565/src/src/pages/notice/[id].vue?macro=true";
import { default as indexylgFCEHMrU_454L6koQX2rEZqNagP8OC00XFsDvWnPcxgMeta } from "/codebuild/output/src1799359565/src/src/pages/coupon/index.vue?macro=true";
import { default as indexcrdEh4Qp2AaUr7P15_t_r_45Pe3_45h61MJ8iZwkZ7llREYMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/index.vue?macro=true";
import { default as indexubef1ODjRx7Bh9A1xGbYlxHefi3_45eRI96IhbpG4F4SAMeta } from "/codebuild/output/src1799359565/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93zr754RvO1Yg40kQS3_45aEfhSpoEQOWoUFqG6yIH5LKL0Meta } from "/codebuild/output/src1799359565/src/src/pages/parking/[id].vue?macro=true";
import { default as indexDAo9BaCkMDlAdlBv1qdKNi74x3r0T8DG_45gLN1Kby5gIMeta } from "/codebuild/output/src1799359565/src/src/pages/history/index.vue?macro=true";
import { default as indexdLkRkmr_89CxG8DTaJ45Ex9xhP5MDuatHmPdiT_y_45RQMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/index.vue?macro=true";
import { default as indexRhn2zjG5ll7haY_45tFyHCJpqnjuPuov9gBnexviLFpiUMeta } from "/codebuild/output/src1799359565/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexLTNJ3Cn53EeNWGNQHdJQMNZvDT6_45zCwU5mzMorK1RKgMeta } from "/codebuild/output/src1799359565/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviXgftma_45Vo_453ak1FViJOxRV6PXVBI3nOQWBL8eAXERcQMeta } from "/codebuild/output/src1799359565/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit0y0W2Bv8s4_oh_45jgp3OCoo6cMdoVW6NM6N0QbTu7ArMMeta } from "/codebuild/output/src1799359565/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementQEL3bonfecTRE_45UWQU90DxUt4TO2bT9FuH9j5e7jN9gMeta } from "/codebuild/output/src1799359565/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexgWLrkWvoKZfMHeCDchAs_45sxHsC5Cy1ULcDtCA35ebM0Meta } from "/codebuild/output/src1799359565/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dLHHkjPes_45_45m8xv0GpbclcGqktHbiDZrKpTfI6v5wd30Meta } from "/codebuild/output/src1799359565/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmGdkfvSJmFjkV6h9SiUPUidiKjGkcU1W5OWfzMdWs29sMeta } from "/codebuild/output/src1799359565/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexXXHUOhXUaJBc9vr3zsUiuEOuJ_aPY12Mn7b9gkOADjIMeta } from "/codebuild/output/src1799359565/src/src/pages/card/create/index.vue?macro=true";
import { default as index1mzbyNzghXFGy2jch01l5ho9XNbC4_45qyw64Cf0ojv_45IMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmnXUs0b_dvGXbz46Pjq_CgdtDySC2YcA0IlXurL1IEBMMeta } from "/codebuild/output/src1799359565/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmA25z0oJ8YSi3IKSJ3_ab9_cRV_45lhq_LB5iMvX1OmfZMMeta } from "/codebuild/output/src1799359565/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete4e1w54tqnZdGjxfB1hmbNHWwqS05ibRbmBl8qCibl30Meta } from "/codebuild/output/src1799359565/src/src/pages/membership/complete.vue?macro=true";
import { default as register178y6U2dVu8rc6qN3YqWY5me2YKLh4RzXdOE_IBg5cUMeta } from "/codebuild/output/src1799359565/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Wib0jaXLhSeqKUzM6Ylv5vv2oAzkWRMHDuT60KXUb48Meta } from "/codebuild/output/src1799359565/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmV0DyahCFyT72AdWS4OII71Na899fufl_vflrBdEpTNwMeta } from "/codebuild/output/src1799359565/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_930T7cz3i5QbD12VzhrpdA1E_zTI1Dll_qyfWOMMX4FuQMeta } from "/codebuild/output/src1799359565/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index3A3VLs9rQJ6aGbf1GvSGRnPYNzyzDniwkSOMyUDAOJUMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeCnsTB1Q7bk3GmYSoO6J7IIVL0o3qf6yN1nU_NNPK0vEMeta } from "/codebuild/output/src1799359565/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codes0OZlpXjzRWyC2t8mqgRxKQWibaqRdmUTz6gbynzcT4Meta } from "/codebuild/output/src1799359565/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeUIZdfFd8f7ux9SZAYQYetCLCggCA6xPxRsB6dwN1Lx8Meta } from "/codebuild/output/src1799359565/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerq8tCEzDu5sjHjK5B_45LdBTtGfxdCFFLFWW6cDYFeMtycMeta } from "/codebuild/output/src1799359565/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete786Zh_mtMDsjXHxaoU6o3_X5xHqEXuuidUEKw0lepqEMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexrtbmwq2gYw3CccXm1_s4a1Hc2NjxZQWtZS1R1DYzikYMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmX47LnZiFDD9FskO3w_u75EqpzEe8CSYM1H3Ca0Ynz9gMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeNx427LMJOQkxN8GJbfZdGdfxkhUJaHghnNiwdkpKamwMeta } from "/codebuild/output/src1799359565/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexw9nIF4qN_457xxMODTkE2QgcoSq1YKgR3eyRKQ93wZiGMMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93FkQQemJXLOuPyjbY1O_45asZfMsrjoNu0W8IG1V01hJhgMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete2Xq9sLBBLLh4p66dXJjzGSniXJBujcmLexX3jFo1aoAMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias3RfrRP_taT0q6WlKXEz1JCfrQSvhP7STkUcKB9voaIQMeta } from "/codebuild/output/src1799359565/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleR8iks4SIuX_ou7t8aDOLg0D5FhSwELzbXCvik4EazYYMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailh2z5S6T9tPDBHJBgXhDXK7sHZkwi0bXWze6wwKpbjssMeta } from "/codebuild/output/src1799359565/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm347R0x0g2oCK64ug3naTA26MNDYajvhYPxitAvSmKs0Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentklZYm3TyeROmi66bGkHcu4If0kzLjiFmoOcUcvNEc68Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmUlzvnQzrdQKoqJtjVtolqHLxtzAVq2tqFQC1eq4VcxMMeta } from "/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatecmps3t5VCpNN4wt7RP8NM_4512p5MnSiSd_45D5CTgZ2vU8Meta } from "/codebuild/output/src1799359565/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completezD4ZOdABLekGsFtfxQmuV3G0Xq_45KQXLvjzuoHpK_Lq0Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code6j_45rfoNjoFPRwtgLJdebBgAFCv_zjy4YuQU7AUfqeQYMeta } from "/codebuild/output/src1799359565/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password693sczOb8RysQnlO2u3cuykd7iCEpDWFRyI262uuuL8Meta } from "/codebuild/output/src1799359565/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliascJo_GwLXiZangO5sUWe0WDEPIDywG0TYWSVBTOT6gDAMeta } from "/codebuild/output/src1799359565/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerDjoUxK5XmY9Dkq6W9b4KWgDH7DK89LkZb4IpYmstM4AMeta } from "/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codes1GPYy5ydBNtVoFxdZNz_DWjXoGADXqB4N0gAKb4xkEMeta } from "/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexOff1uYui_7oc8EIAl_tVy9tr513u6xWHGkNOlbv4EeUMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexjqBv7kq0wzX4YDzrOaf6SRUrg_UYqtSMA0kcraog5acMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexO3T9FPxzr8ulxV1GoSffvyMZzOYG_45anpY1Sv_45tu3_XoMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexRYarGWdgJm3cJ2xzTeM_ZD1XDGpvh_454FLOee7UEdh_45MMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatescH62gDYGq3VW_XttxaAm6ca31pqnDgldcFZUw8BcC8Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completevWzV9XRgnZRbPemjt_459d6tAlbzgIFmM_Vrvk_ifj_PcMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmsDq9P5ZTssBGy2w50ZZcivswUFK2X75f5EnDN4Cz5KoMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index7XBNsQWr7_45JwxMuwPORvAY7TdRSKI7uHjrWT9BBzJmcMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completesD1A_cyIpHYDGXoeFyzoz2dlaGt8QM26MGz0lPTnUDYMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update_45jAcVLzRv_6H0WfiJBbMvVs7xffU2vJpBbK_45aCN3la8Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexDykNPgWPVuzrHkpv9xJu0nQ3kZ_ZWM65_rMhcwFVSHwMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexmNr_45tzVsQJjQbi6BcLxMDFVvUo_451qaQkzUEj40FZ228Meta } from "/codebuild/output/src1799359565/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completevJwX5QLydN8YnVAaPwYs8_10f4Pt8G6FWvqFedmlmboMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexQRbHlipnSnqK09yPajs70iSlq2gqhlZr3u_Xt_YwilgMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeA_45qFEwDHwXU0nfSkis4rLcUw2UiFaR0MGwTpj_CtCg4Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexLpvN5ZvWQCAc_TeGNurDl1wmNKhB85UlfoIsRLwfKz4Meta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexClJBVcQHtTS0ZpnBKRKI3qt2_45kHc6GzVL_d04Z07Bn8Meta } from "/codebuild/output/src1799359565/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexWZ73HjN0WXLE8c0GWpXwB_45NU2mfd4vqtOvCRiTEj2hIMeta } from "/codebuild/output/src1799359565/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateMsBcr64FOVqM6S3FuqKbDFu3x1_45SQDOwDq8FpKA2pdwMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmJH87taLIAkQUS9isLC_8_45Mv5pmMc2FYIpqtrfrmNPakMeta } from "/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuFSYBgNDbir88gc_45_45u8S7C6Hl0APDWMxct9P0SOWpoAgMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexes1xavIQ_459mQ0U4tlu5D5VJjbV7TWm3D_yFsY8Xsy1UMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexylgFCEHMrU_454L6koQX2rEZqNagP8OC00XFsDvWnPcxgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexDAo9BaCkMDlAdlBv1qdKNi74x3r0T8DG_45gLN1Kby5gIMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexRhn2zjG5ll7haY_45tFyHCJpqnjuPuov9gBnexviLFpiUMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexLTNJ3Cn53EeNWGNQHdJQMNZvDT6_45zCwU5mzMorK1RKgMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexXXHUOhXUaJBc9vr3zsUiuEOuJ_aPY12Mn7b9gkOADjIMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmnXUs0b_dvGXbz46Pjq_CgdtDySC2YcA0IlXurL1IEBMMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmA25z0oJ8YSi3IKSJ3_ab9_cRV_45lhq_LB5iMvX1OmfZMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete4e1w54tqnZdGjxfB1hmbNHWwqS05ibRbmBl8qCibl30Meta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register178y6U2dVu8rc6qN3YqWY5me2YKLh4RzXdOE_IBg5cUMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmV0DyahCFyT72AdWS4OII71Na899fufl_vflrBdEpTNwMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeCnsTB1Q7bk3GmYSoO6J7IIVL0o3qf6yN1nU_NNPK0vEMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codes0OZlpXjzRWyC2t8mqgRxKQWibaqRdmUTz6gbynzcT4Meta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeUIZdfFd8f7ux9SZAYQYetCLCggCA6xPxRsB6dwN1Lx8Meta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerq8tCEzDu5sjHjK5B_45LdBTtGfxdCFFLFWW6cDYFeMtycMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmX47LnZiFDD9FskO3w_u75EqpzEe8CSYM1H3Ca0Ynz9gMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeNx427LMJOQkxN8GJbfZdGdfxkhUJaHghnNiwdkpKamwMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexw9nIF4qN_457xxMODTkE2QgcoSq1YKgR3eyRKQ93wZiGMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete2Xq9sLBBLLh4p66dXJjzGSniXJBujcmLexX3jFo1aoAMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleR8iks4SIuX_ou7t8aDOLg0D5FhSwELzbXCvik4EazYYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailh2z5S6T9tPDBHJBgXhDXK7sHZkwi0bXWze6wwKpbjssMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm347R0x0g2oCK64ug3naTA26MNDYajvhYPxitAvSmKs0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentklZYm3TyeROmi66bGkHcu4If0kzLjiFmoOcUcvNEc68Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmUlzvnQzrdQKoqJtjVtolqHLxtzAVq2tqFQC1eq4VcxMMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completezD4ZOdABLekGsFtfxQmuV3G0Xq_45KQXLvjzuoHpK_Lq0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code6j_45rfoNjoFPRwtgLJdebBgAFCv_zjy4YuQU7AUfqeQYMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password693sczOb8RysQnlO2u3cuykd7iCEpDWFRyI262uuuL8Meta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerDjoUxK5XmY9Dkq6W9b4KWgDH7DK89LkZb4IpYmstM4AMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codes1GPYy5ydBNtVoFxdZNz_DWjXoGADXqB4N0gAKb4xkEMeta || {},
    component: () => import("/codebuild/output/src1799359565/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1799359565/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]